// @ts-nocheck
import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { useI18n } from '../i18n/I18nContext.jsx';
import { track } from '../analytics/events.js';
import { X } from 'lucide-react';

let searchModulePromise;

function loadSearchModule() {
  searchModulePromise ??= import('../content/search-index.js');
  return searchModulePromise;
}

const searchCopy = {
  ru: { scope: 'Поиск по опубликованным материалам', title: 'Найти решение', label: 'Поисковый запрос', placeholder: 'Маркировка, сериализация, упаковка…', searching: 'Ищем…', empty: 'Среди опубликованных материалов ничего не найдено.', close: 'Закрыть поиск' },
  uz: { scope: 'E’lon qilingan materiallar bo‘yicha qidiruv', title: 'Yechimni topish', label: 'Qidiruv so‘rovi', placeholder: 'Markirovka, serializatsiya, qadoqlash…', searching: 'Qidirilmoqda…', empty: 'E’lon qilingan materiallar orasida hech narsa topilmadi.', close: 'Qidiruvni yopish' },
  en: { scope: 'Search published materials', title: 'Find a solution', label: 'Search query', placeholder: 'Marking, serialization, packaging…', searching: 'Searching…', empty: 'Nothing was found among the published materials.', close: 'Close search' },
};

export function SearchDialog({ open, onClose }) {
  const { locale } = useI18n();
  const copy = searchCopy[locale] || searchCopy.ru;
  const [query, setQuery] = useState(''); const [results, setResults] = useState([]); const [loading, setLoading] = useState(false);
  const input = useRef(null); const dialog = useRef(null); const closeButton = useRef(null);
  useEffect(() => {
    if (!open) return undefined;
    input.current?.focus();
    const closeOnKey = event => {
      if (event.key === 'Escape') onClose();
      if (event.key === 'Tab') {
        const focusable = dialog.current?.querySelectorAll('button,input,a[href]');
        if (!focusable?.length) return;
        const first = focusable[0]; const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      }
    };
    document.addEventListener('keydown', closeOnKey); return () => document.removeEventListener('keydown', closeOnKey);
  }, [open, onClose]);
  async function handleQuery(value) {
    setQuery(value);
    if (value.trim().length < 2) { setResults([]); setLoading(false); return; }
    setLoading(true);
    try {
      const { searchEntireSite } = await loadSearchModule();
      const nextResults = await searchEntireSite(value, locale);
      setResults(nextResults);
    } catch {
      setResults([]);
    } finally {
      setLoading(false);
    }
  }
  if (!open) return null;
  return <div className="search-backdrop" onMouseDown={event => { if (event.target === event.currentTarget) onClose(); }}><div ref={dialog} className="search-dialog" role="dialog" aria-modal="true" aria-labelledby="search-title"><div><span>{copy.scope}</span><button ref={closeButton} type="button" onClick={onClose} aria-label={copy.close}><X aria-hidden="true"/></button></div><h2 id="search-title">{copy.title}</h2><label><span className="sr-only">{copy.label}</span><input ref={input} value={query} onChange={event => { handleQuery(event.target.value); if (event.target.value.length === 2) track('search', { locale, source: 'header' }); }} placeholder={copy.placeholder} autoComplete="off"/></label><div className="search-results" aria-live="polite" aria-busy={loading}>{loading && <p>{copy.searching}</p>}{!loading && query.length >= 2 && results.length === 0 && <p>{copy.empty}</p>}{results.map(result => <Link key={result.id} to={result.path} onClick={onClose}><small>{result.kind}</small><strong>{result.title}</strong>{result.summary && <span>{result.summary}</span>}</Link>)}</div></div></div>;
}
